"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MixpanelTracker = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _base = require("./base");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* eslint-disable class-methods-use-this */
var debug = (0, _debug.default)('rentspree-tracker:mixpanel');

/**
 * Class For Mixpanel tracker
 * This is a complex class working directly with Mixpanel Lib
 * It ensure the readiness of Mixpanel.js library and prepare API for React
 * @extends BaseTracker
 */
var MixpanelTracker = exports.MixpanelTracker = /*#__PURE__*/function (_BaseTracker) {
  _inherits(MixpanelTracker, _BaseTracker);
  function MixpanelTracker() {
    _classCallCheck(this, MixpanelTracker);
    return _callSuper(this, MixpanelTracker, arguments);
  }
  _createClass(MixpanelTracker, [{
    key: "callIfReady",
    value: function callIfReady(fnName) {
      var _this = this;
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      // return when it had been recursively called for too much
      if (recursive > 5) return;
      if (!MixpanelTracker.checkReady()) {
        setTimeout(function () {
          debug('postpone %s for 0.5 second', fnName);
          _this.callIfReady.apply(_this, [fnName, recursive + 1].concat(args));
        }, 500);
      }

      // call the function
      this[fnName].apply(this, args);
    }
  }, {
    key: "_trackPageView",
    value: function _trackPageView(url, path, properties) {
      var obj = {
        url: url,
        path: path,
        properties: properties
      };
      debug('track pageview for object %0', obj);
      MixpanelTracker.getTracker().track('page viewed', _objectSpread({
        url: url,
        path: path
      }, properties));
    }

    /**
     * Track the page view by calling `mixpanel.track("page viewd", ...)`
     * @param {String} url the url to track
     * @param {String} path the path
     * @param {Object} properties the additional properties
     */
  }, {
    key: "trackPageView",
    value: function trackPageView(url, path) {
      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.callIfReady('_trackPageView', 0, url, path, properties);
    }

    /**
     * Identify the user
     * this will call two mixpanel methods
     * - `mixpanel.identify` sending `mapUserIdentity(profile)`
     * - `mixpanel.people.set` sending (`mapUserProfile(profile)`
     * @param {Object} profile the user object to be mapped and sent to Mixpanel
     */
  }, {
    key: "identifyUser",
    value: function identifyUser(profile, ip) {
      debug('identify user %o', profile);
      MixpanelTracker.getTracker().identify(this.mapUserIdentity(profile));
      MixpanelTracker.getTracker().people.set(this.mapUserProfile(profile, ip));
    }
  }, {
    key: "_trackEvent",
    value: function _trackEvent(eventName) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      debug('track event for name:%s, properties:%o', eventName, properties);
      MixpanelTracker.getTracker().track(eventName, properties);
    }

    /**
     * Track the event by calling `mixpanel.track(eventName, properties)`
     * @param {String} eventName the eventName
     * @param {Object} properties the properties object to be passed to Mixpanel
     */
  }, {
    key: "trackEvent",
    value: function trackEvent(eventName) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.callIfReady('_trackEvent', 0, eventName, properties);
    }

    /**
     * Setup alias to identify user when that user signup successfully
     * by calling `mixpanel.alias(alias)`
     * @param {String} alias the alias to define alias of user
     */
  }, {
    key: "setAliasUser",
    value: function setAliasUser(alias) {
      debug('set alias uesr with name:%s', alias);
      MixpanelTracker.getTracker().alias(alias);
    }
  }], [{
    key: "getTracker",
    value:
    /**
     * Static method for getting the tracker from window
     * @returns {Object | Proxy} the mixpanel object, if the object is not existed in window.mixpanel,
     * this method will return Proxy to avoid error
     * @static
     */
    function getTracker() {
      if (window && window.mixpanel) {
        return window.mixpanel;
      }
      debug('return proxy object for now');
      return new Proxy({}, {
        get: function get() {
          return function () {};
        }
      });
    }

    /**
     * Check if mixpanel object is ready by checking `window.mixpanel.__loaded
     * @returns {Boolean} wether the mixpanel object is ready
     * @static
     */
  }, {
    key: "checkReady",
    value: function checkReady() {
      if (window && window.mixpanel) {
        debug('mixpanel is ready: %s', window.mixpanel.__loaded); // eslint-disable-line no-underscore-dangle
        return !!window.mixpanel.__loaded; // eslint-disable-line no-underscore-dangle
      }
      return false;
    }
  }]);
  return MixpanelTracker;
}(_base.BaseTracker);